import { render, staticRenderFns } from "./CombinationsProductDropdowns.vue?vue&type=template&id=188544f7&scoped=true"
import script from "./CombinationsProductDropdowns.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsProductDropdowns.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsProductDropdowns.vue?vue&type=style&index=0&id=188544f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188544f7",
  null
  
)

export default component.exports